import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { DataActions, ServicePlanActions } from "../actions";
import { ServicePlansDbService } from "../services/service-plan-db.service";

@Injectable()
export class ServicePlanEffects {
    constructor(private actions$: Actions, private servicePlansDbService: ServicePlansDbService) {}

    getServicePlans$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ServicePlanActions.load),
            switchMap(() =>
                DataActions.toAction2()(
                    this.servicePlansDbService.getAllServicePlans().pipe(map(servicePlans => ({ servicePlans }))),
                    ServicePlanActions.loadSuccess,
                    ServicePlanActions.loadFailure
                )
            )
        )
    );
}
